/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.actividad': 'Actividad',
  'sidebar.clasificaciones': 'Actividad',
  'clasificaciones.agregarClasificaciones': 'Crear Actividad',
  'clasificaciones.modificarClasificaciones': 'Editar Actividad',
  'clasificaciones.clasificacionId': 'Actividad Id',
  'clasificaciones.empresaId': 'Empresa Id',
  'clasificaciones.clasificacionDescripcion': 'Nombre Actividad ',
  'clasificaciones.VerClasificaciones': 'Ver Actividad',
};
